module.exports = __webpack_public_path__ + "img/part8_bg.ac6a0dfd.png";